import { Routes } from '@angular/router';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { OrdersComponent } from './orders/orders.component';

export const OrderRoutingModule: Routes = [
	{ path: 'home', component: OrdersComponent },
	{ path: 'orders', component: OrdersComponent },
	{ path: 'orders/:orderId', component: OrderDetailsComponent },
];
